import Vue from 'vue'
import ut from '@/utils'

import {Resource} from 'vue-resource'

const Contract = {
  id: null,
  code: '',
  reg_number: '',
  price: '',
  comment: '',
  counteragent: null,
}

const ContractResource = new Resource('/', {}, {
  list: {
    method: 'GET',
    url: 'contracts/list/',
  },
  listForCounteragent: {
    method: 'GET',
    url: 'counteragent/list/with_contracts/',
  },
  details: {
    method: 'GET',
    url: 'contracts/detail/{id}/',
  },
  create: {
    method: 'POST',
    url: 'contracts/create/',
  },
  update: {
    method: 'PUT',
    url: 'contracts/update/{id}/',
  },
  remove: {
    method: 'DELETE',
    url: 'contracts/delete/{id}/',
  },
})

export default {
  namespaced: true,

  state: {
    data: null,

    fetching: false,
    model: ut.deepClone(Contract),

    saving: false,
    deleting: {}
  },

  getters: {
    getContract: (state) => (id) => state.data?.results?.find(m => m.id === id),
  },

  mutations: {
    setItems(state, data) {
      state.data = data
    },

    setModel(state, data) {
      state.model = {...ut.deepClone(Contract), ...data}

      if (state.model.counteragent && ('object' === typeof state.model.counteragent)) {
        state.model.counteragent_full_name = state.model.counteragent.full_name
        state.model.counteragent = state.model.counteragent.id
      }
    },
  },

  actions: {
    fetch({state, commit}, filters = {}) {
      filters.limit = filters.limit || 1000

      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = ContractResource.list(ut.objFilter(filters))
          .then((response) => {
            commit('setItems', response.body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    fetchForCounteragent({state, commit}, filters = {}) {
      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = ContractResource.listForCounteragent(ut.objFilter(filters))
          .then((response) => {
            commit('setItems', response.body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    show({state, commit}, id) {
      if (!state.fetching) {
        commit('setModel', {})
        state.fetching = ContractResource.details({id})
          .then(({body}) => {
            commit('setModel', body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    save({state, commit}) {
      state.saving = true
      let promise
      if (state.model.id) {
        promise = ContractResource.update({id: state.model.id}, state.model)
      } else {
        promise = ContractResource.create(state.model)
      }

      return promise
        .then(({body}) => {
          commit('setModel', body)
        })
        .finally(() => state.saving = false)
    },

    remove({state, dispatch}, id) {
      Vue.set(state.deleting, id, true)
      return ContractResource.remove({id})
        .then(() => dispatch('fetch'))
        .finally(() => Vue.set(state.deleting, id, false))
    },
  },
}
